import { render, staticRenderFns } from "./ReportsIcon.vue?vue&type=template&id=676222c3&"
import script from "./ReportsIcon.vue?vue&type=script&lang=js&"
export * from "./ReportsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports